import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSearchParams } from 'react-router-dom';
import { PayrollBonusFilters } from './BonusFilters';

const BonusParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { setValue } = useFormContext<PayrollBonusFilters>();

  useEffect(() => {
    let value = searchParams.get('submittedID');
    if (value) {
      setValue('submittedID', value);
      setSearchParams();
    }
  }, [searchParams]);

  return <span />;
};

export default BonusParams;
